import React from 'react'
import cn from 'classnames'

import './Grid.less'

type GridProps = {
  className?: string
  children?: React.ReactNode
}

export function Grid({ className, children }: GridProps) {
  return <div className={cn('grid-container', className)}>{children}</div>
}

type RowProps = {
  className?: string
  children?: React.ReactNode
}

export function Row({ className, children }: RowProps) {
  return <div className={cn('grid-row', className)}>{children}</div>
}

type ColProps = {
  sm?: number
  smPush?: number
  className?: string
  children?: React.ReactNode
}

export function Col({ sm, smPush, className, children }: ColProps) {
  const colClass = cn(
    'grid-col',
    sm != null && `grid-col-sm-${sm}`,
    smPush != null && `grid-col-sm-push-${smPush}`,
    className,
  )
  return <div className={colClass}>{children}</div>
}
